// Fixed aurora + masked grid behind the redesigned homepage.
const PageBackdrop = () => (
  <>
    <div className="r-page-bg" aria-hidden="true" />
    <div className="r-page-grid" aria-hidden="true" />
  </>
);

export default PageBackdrop;
